import { useLocalSearchParams } from 'expo-router';

import VideoDebugVariationScreen from '@/components/VideoDebugVariationScreen';

export default function VideoDebugVariationRoute() {
  const { variation, videoId } = useLocalSearchParams<{
    variation?: string;
    videoId?: string;
  }>();
  return (
    <VideoDebugVariationScreen variationId={variation} videoId={videoId} />
  );
}
